// core version + navigation, pagination modules:
import Swiper, {
    Navigation,
    Controller,
    Autoplay,
    Pagination,
    EffectFade,
} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
export default {
    when() {
        return document.querySelectorAll('.slider').length > 0;
    },

    mounted() {
        // Header Slider

        const swiperHeaderImage = new Swiper('.swiper-header-image', {
            // configure Swiper to use modules
            modules: [Pagination, Controller],
            loop: false,
            controller: {
                by: 'container',
                control: swiperHeader,
            },
            allowTouchMove: false,
        });
        const swiperHeader = new Swiper('.swiper-header', {
            // configure Swiper to use modules
            modules: [Navigation, Controller, Autoplay, Pagination, EffectFade],
            navigation: {
                nextEl: '.swiper-header-button-next',
                prevEl: '.swiper-header-button-prev',
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: false,
            direction: 'vertical',
            controller: {
                by: 'container',
                control: swiperHeaderImage,
            },
            allowTouchMove: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                // verticalClass: 'swiper-pagination-vertical',
            },
            autoplay: {
                delay: 8000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
            },
            click: function(event) {
                swiperHeaderImage.autoplay.stop();
            }
        });

        // Latest News Slider
        const swiperLatestNews = new Swiper('.swiper-latest-news', {
            // configure Swiper to use modules
            loop: false,
            allowTouchMove: true,
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-latest-news-button-next',
                prevEl: '.swiper-latest-news-button-prev',
            },
            breakpoints: {
                // when window width is >= 320px
                0: {
                    slidesPerView: 1.1,
                    slidesOffsetAfter: 16,
                    spaceBetween: 16,
                },
                // when window width is >= 480px
                440: {
                    slidesPerView: 1.3,
                    slidesOffsetAfter: 20,
                    spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 1.7,
                    spaceBetween: 24,
                    slidesOffsetAfter: 24,
                },
                768: {
                    slidesPerView: 2.3,
                    spaceBetween: 28,
                    slidesOffsetAfter: 28,
                },
                1024: {
                    slidesPerView: 2.6,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                },
                1280: {
                    slidesPerView: 2.8,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                },
            },
        });
    },
};
